import * as React from 'react';
import * as styles from './deleteButton.css';

import { Button } from '@cian/button-component';
import { TrashIcon } from '../icons';

export interface IDeleteButtonProps {
  showPreloader: boolean;
  onDeleteCommentClick(): void;
}

export class DeleteButton extends React.PureComponent<IDeleteButtonProps, {}> {
  public render() {
    const { onDeleteCommentClick, showPreloader } = this.props;

    return (
      <div className={styles.delete_button}>
        <Button
          size="S"
          theme="ghost"
          isSync={showPreloader}
          onClick={onDeleteCommentClick}
          className={styles.round_button}
        >
          <TrashIcon />
        </Button>
      </div>
    );
  }
}
